<header>
  <div class="header desktop-view">
    <a rel="preload" [routerLink]="['']"
      ><img alt="Broadfactor logo" src="../../../assets/img/logo.png"
    /></a>
    <div>
      <button mat-button routerLink="home" color="primary">Início</button>

      <button
        mat-button
        [matMenuTriggerFor]="menuCompany"
        routerLinkActive="active"
      >
        Quem somos
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menuCompany="matMenu">
        <button
          routerLink="broadfactor/sobre"
          routerLinkActive="mat-button mat-primary"
          mat-menu-item
          class="menu-item"
        >
          Sobre a Broadfactor
        </button>
        <button
          mat-menu-item
          routerLink="broadfactor/trabalhe-conosco"
          routerLinkActive="mat-button mat-primary"
          class="menu-item"
        >
          Trabalhe conosco
        </button>
      </mat-menu>

      <button mat-button [matMenuTriggerFor]="menuSolutions">
        Para o seu negócio
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menuSolutions="matMenu">
        <button
          mat-menu-item
          class="menu-item"
          onclick="window.open('https://antecipagov.com.br/home')"
          routerLinkActive="mat-button mat-primary"
        >
          <div>
            <span>AntecipaGov</span>
          </div>
        </button>
        <button
          mat-menu-item
          class="menu-item"
          onclick="window.open('https://broadfactorpay.com/home')"
          routerLinkActive="mat-button mat-primary"
        >
          <div>
            <span>BroadfactorPay</span>
          </div>
        </button>
        <button
          mat-menu-item
          class="menu-item"
          onclick="window.open('https://recebiveis.broadfactor.com')"
        >
          <div>
            <span>Plataforma Privada</span>
          </div>
        </button>
      </mat-menu>

      <button mat-button routerLink="contatos" routerLinkActive="active">
        Fale Conosco
      </button>
      <button mat-button onclick="window.open('https://blogbroadfactor.com')">
        Blog
      </button>
    </div>
  </div>
  <div class="header mobile-view">
    <a [routerLink]="['']"
      ><img
        width="150px"
        alt="Broadfactor logo"
        height="auto"
        src="../../../assets/img/logo.png"
    /></a>

    <button mat-button [matMenuTriggerFor]="menuMd">
      <mat-icon>menu</mat-icon>
    </button>

    <mat-menu #menuMd="matMenu" xPosition="before">
      <button
        mat-menu-item
        [matMenuTriggerFor]="menuSolutions"
        routerLink="solucoes"
        routerLinkActive="active"
      >
        Para o seu negócio
      </button>
      <button
        mat-menu-item
        [matMenuTriggerFor]="menuCompany"
        routerLink="broadfactor"
        routerLinkActive="active"
      >
        Quem somos
      </button>
      <button mat-menu-item routerLink="contatos" routerLinkActive="active">
        Contato
      </button>
      <button
        mat-menu-item
        onclick="window.open('https://blogbroadfactor.com')"
      >
        Blog
      </button>
    </mat-menu>

    <mat-menu #menuSolutions="matMenu">
      <button
        mat-menu-item
        onclick="window.open('https://antecipagov.com.br/home')"
        routerLinkActive="mat-button mat-primary"
      >
        AntecipaGov
      </button>
      <button
        mat-menu-item
        onclick="window.open('https://broadfactorpay.com/home')"
        routerLinkActive="mat-button mat-primary"
      >
        BroadfactorPay
      </button>
      <button
        mat-menu-item
        onclick="window.open('https://recebiveis.broadfactor.com')"
      >
        Plataforma Privada
      </button>
    </mat-menu>

    <mat-menu #menuCompany="matMenu">
      <button
        mat-menu-item
        routerLink="broadfactor/sobre"
        routerLinkActive="mat-button mat-primary"
      >
        Quem somos
      </button>
      <button
        mat-menu-item
        routerLink="broadfactor/trabalhe-conosco"
        routerLinkActive="mat-button mat-primary"
      >
        Trabalhe conosco
      </button>
    </mat-menu>
  </div>
</header>
